module.exports = {"211221101":"新台子镇","211221102":"阿吉镇","211221103":"平顶堡镇","211221104":"大甸子镇","211221105":"凡河镇","211221106":"腰堡镇","211221107":"镇西堡镇","211221108":"蔡牛镇","211221109":"李千户镇","211221110":"熊官屯镇","211221111":"横道河子镇","211221112":"双井子镇","211221208":"鸡冠山乡","211221209":"白旗寨满族乡","211221401":"种畜场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211221.json
// module id = 537
// module chunks = 0